import React from "react";
import SubmitButton from "../submitButton/SubmitButton";
import { useNavigate } from "react-router-dom";
const LoginPrompt = ({ message = "to access this feature" }) => {
  const navigate = useNavigate();
  return (
    <div className="text-center bg-white p-5 w-100 br_10">
      <p>Please Login or Register {message}.</p>
      <div className="d-flex justify-content-center gap-2">
        <SubmitButton
          style={{ marginTop: "0px" }}
          className="mt-0 rounded-pill"
          onClick={() => navigate("/login")}
          label="Login"
        />
        <SubmitButton
          style={{ marginTop: "0px" }}
          className="mt-0 rounded-pill btn-master-line"
          onClick={() => navigate("/Register")}
          label="Register"
        />
      </div>
    </div>
  );
};

export default LoginPrompt;
